<template>
  <v-dialog
    v-model="exibedialogInterno"
    fullscreen
    hide-overlay
    transition="dialog-bottom-transition"
  >
    <v-card>
      <v-toolbar
      dark
      color="primary"
      >
        <v-btn
        icon
        dark
        @click="fechaDialog()">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <v-toolbar-title>Cadastro de ficha</v-toolbar-title>
        <v-spacer />
        <v-toolbar-items>
          <v-btn
            dark
            text
            @click="fechaDialog()"
          >
            Fechar
          </v-btn>
        </v-toolbar-items>        
      </v-toolbar>
        <v-form>
          <v-tabs 
            fixed-tabs
            background-color="primary"
          >
          <v-tab href="#dados">
            Dados
          </v-tab>
          <v-tab href="#animais">
            Animais
          </v-tab>
          <v-tab-item value="dados">
          <v-container class="py-0">
            <v-col
              cols="12"
              md="6"
            >
              <p v-if="erros.length">
                <b>Por favor, corrija o(s) seguinte(s) erro(s):</b>
                <ul>
                  <li v-for="item in erros" :key="item" >
                    {{ item }}
                  </li>
                </ul>
              </p>
            </v-col>
            <v-col
              cols="12"
              md="6"
            >
            <v-combobox
                v-model="form.tipoFicha"
                :items="tipoFichaList"
                label="Tipo:"
                class="purple-input"
                item-text="nome"
                clearable
                return-object
              ></v-combobox>
            </v-col>           
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.descricao"
                class="purple-input"
                label="Descrição:"
              />
            </v-col>            
            <template v-if="form.tipoFicha != null && form.tipoFicha.resultado == 'NUMERO' ">
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field
                v-model="form.valorNumero"
                class="purple-input"
                label="Valor:"
                type="number"
                v-on:blur="doChangeV()"

              />
            </v-col>
            </template>
            <template v-if="form.tipoFicha != null && form.tipoFicha.resultado == 'INTEIRO' ">
            <v-col
              cols="12"
              md="6"
            >
              <v-text-field         
                v-model="form.valorInteiro"
                class="purple-input"
                label="Valor:"
                v-on:blur="doChangeV()"
              />
            </v-col>
            </template>
            <!-- <template v-if="form.tipoFicha != null && form.tipoFicha.resultado == 'DATA' "> -->
          <template >
            <v-col
              cols="12"
              md="6"
            >
              <v-menu
                ref="menuData"
                v-model="menuData"
                :close-on-content-click="false"
                transition="scale-transition"
                min-width="290px"
                offset-y>
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="form.valorData"
                    class="purple-input"
                    label="Data do evento"
                    readonly
                    clearable
                    v-on="on"/>
                </template>
                <v-date-picker
                  v-model="dataC"
                  class="purple-input"
                  no-title
                  scrollable
                  @input="menuData = false"/>
              </v-menu>
            </v-col>
            </template>
            <template v-if="form.tipoFicha != null && form.tipoFicha.resultado == 'BOLEANO' ">
            <v-col
              cols="12"
              md="6"
              class="align-self-center"
            >
              <v-checkbox          
                v-model="form.valorBoleano"
                class="purple-input"
                label="Valor:"
                v-on:change="doChangeV()"
              />
            </v-col>  
            </template>
            <v-col
              class="text-right"
              cols="12"
            >
              <v-btn
                class="mx-0 font-weight-light"
                color="success"
                @click="doSalva"
              >
                Salvar
              </v-btn>
            </v-col>
          </v-container>
          </v-tab-item>
          <v-tab-item value="animais">
              <v-container class="py-0">
                <v-col cols="12"
                 md="6"
                >
                <v-combobox 
                    v-model="filtro.especie"
                    :items="especieList"
                    label="Espécie:"
                    class="purple-input"
                    item-text="nome"
                    clearable
                    return-object
                  ></v-combobox>
                </v-col>
                <v-col cols="12"
                 md="6" >
                  <v-combobox 
                      v-model="filtro.pessoa"
                      :items="pessoaList"
                      label="Proprietário:"
                      class="purple-input"
                      item-text="nome"
                      clearable
                      return-object
                    ></v-combobox>   
                </v-col>    
                <v-col cols="12"
                 md="6" >
                  <v-btn
                    small
                    color="default"
                    @click="doBuscaAnimal">
                    Buscar  
                  </v-btn>
                </v-col>
              </v-container>
              <v-row>
              <v-col
                cols="4"
                class="pr-0 mr-0"
              >
                <v-list dense>
                  <v-subheader>Disponiveis</v-subheader>
                  <v-list-item-group
                    v-model="animalSelecionado"
                    color="primary">
                    <v-list-item  v-for="(item, i) in animaisDisponiveis"
                    :key="i">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.titulo"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              <v-col 
              cols="1" 
              class="pa-2 pt-14" >
                <v-btn
                small
                color="default"
                @click="doAddVariosForm">
                >>
                </v-btn>
                <v-btn
                small
                color="default"
                @click="doAddForm">
                >
                </v-btn>         
                <v-btn
                small
                color="default"
                @click="doRemoveForm">
                &lt;
                </v-btn>
              </v-col>
              <v-col
                cols="4"
                class="pr-0 mr-0"
              >              
                <v-list dense>
                  <v-subheader>Selecionados</v-subheader>
                  <v-list-item-group
                    v-model="animalRemover"
                    color="primary">                    
                    <v-list-item  v-for="(item, i) in form.fichaAnimais"
                    :key="i">
                      <v-list-item-content>
                        <v-list-item-title v-text="item.animal.titulo"></v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list-item-group>
                </v-list>
              </v-col>
              </v-row>
          </v-tab-item>
          </v-tabs>          
        </v-form>

    </v-card>
  </v-dialog>
</template>

<script>
import service from "../../../services/fichaservice";
import utils from "../../../services/utils";
import serviceanimal from "../../../services/animalservice";
import servicepessoa from "../../../services/pessoaservice";
import servicetipoficha from "../../../services/tipofichaservice";
import serviceespecie from "../../../services/especieservice";

export default {
  directives: {},
  props: {
    exibedialog: {
      type: Boolean,
      default: false,
    },
    fichaObj: {
      type: Object,
      default: function () {
        return {
          id: -1,
          fichaAnimais: [],
          tipoFicha: null,
          descricao: "",
          valorNumero: 0.0,
          valorInteiro: 0,
          valorBoleano: false,
          valorData: "",
        };
      },
    },
  },
  watch: {
    exibedialog: function (val) {
      this.exibedialogInterno = val;
    },
    fichaObj: function (val) {
      this.form = val;
      if (!this.form) {
        this.iniciaForm();
      } else {
        this.dataC = this.form.valorData;
        this.doChangeV();
      }
    },
    dataC: function (val, oldVal) {
      this.form.valorData = utils.methods.gettanggal(val);
      if (
        this.form.tipoFicha != null &&
        this.form.tipoFicha.resultado == "DATA"
      )
        this.doChangeV();
    },
  },
  data: () => ({
    form: {
      id: -1,
      fichaAnimais: [],
      tipoFicha: null,
      descricao: "",
      valorNumero: 0.0,
      valorInteiro: 0,
      valorBoleano: false,
      valorData: "",
    },
    filtro:{
      especie: null,
      pessoa: null,
    },
    fichaAnimal: {
      id: -1,
      animal: null,
    }, 
    pessoaList: [],
    especieList: [],
    tipoFichaList: [],
    animaisDisponiveis: [],

    animalRemoverList: [],
    animalSelecionado: null,
    animalRemover: null,
    exibedialogInterno: false,
    nomeErro: false,
    erros: [],
    menu1: false,
    menuData: false,
    dataC: "",
  }),
  mounted() {
    this.iniciaForm()
    this.doCarregaForm()
  },
  computed: {
    // animaisDisponiveis: function() {
    //   if (this.form != null || this.form.fichaAnimais != null)
    //     return this.animalList
    //   else
    //     return this.animalList.filter(item => this.form.fichaAnimais.filter(i => i.animal == item) );
    // },
  },
  methods: {
    iniciaForm() {
      this.form.id = -1;
      (this.form.fichaAnimais = []),
        (this.form.tipoFicha = null),
        (this.form.descricao = ""),
        (this.form.valorNumero = 0.0),
        (this.form.valorInteiro = 0),
        (this.form.valorBoleano = false),
        (this.form.valorData = ""),        
        this.animalRemoverList = []
        this.animaisDisponiveis = []
        this.especieList = []
        this.pessoaList = []
    },
    doCarregaForm(){

      servicepessoa.listar().then((resposta) => {
        this.pessoaList = resposta.data.list
      })
      servicetipoficha.listarAtivo().then((resposta) => {
        this.tipoFichaList = resposta.data.list
      })
      serviceespecie.listar().then((resposta) => {
        this.especieList = resposta.data.list
      })
    },
    doBuscaAnimal(){
      console.log(this.filtro)
      serviceanimal.listarAtivoFiltro(this.filtro).then((resposta) => {
        
      console.log(resposta.data)
        this.animaisDisponiveis = resposta.data.list
      }).catch(e => {
          console.log( e)                      

        })
    },
    fechaDialog() {
      this.exibedialogInterno = false;
      this.$emit("update-dialog", this.exibedialogInterno)
    },
    doSalva() {

      if (!this.doValidate()) {
        return;
      }
      if (this.animalRemoverList.length > 0) {
        service.removerAnimal(this.form, this.animalRemoverList).then((resposta) => {
          this.animalRemoverList = []
        })
        .catch((e) => {
          console.log(e)
        })
      } 
      service.salvar(this.form).then((resposta) => {
        if (resposta.status === 200) {
          this.fechaDialog()
          this.iniciaForm()


        }
      }).catch((e) => {
        if (e.message === "Network Error") {
          console.log("Network Error: " + e.response)
        } else {
          console.log(e)
        }
      });
    },
    doValidate() {
      this.erros = []
      if (this.form.fichaAnimais.length == 0)
        this.erros.push("Favor preencher: Animal")
      if (!this.form.tipoFicha) this.erros.push("Favor preencher: Tipo Ficha")
      if (this.erros.length === 0) {
        return true;
      }
    },
    doAddForm() {
      if (this.animalSelecionado != null) {

        this.form.fichaAnimais.push({id: -1, animal: this.animaisDisponiveis[this.animalSelecionado]} )
        var xx = this.animaisDisponiveis.indexOf(this.animaisDisponiveis[this.animalSelecionado])
        if(xx > -1)
          this.animaisDisponiveis.splice(xx, 1)
      }
    },
    doAddVariosForm() {
      for (var k = 0; k < this.animaisDisponiveis.length; k++) {
        this.form.fichaAnimais.push(this.animaisDisponiveis[k]);
      }
      this.animaisDisponiveis = []
    },
    doRemoveForm() {
      if (this.animalRemover != null) {
        var xx = this.form.fichaAnimais.indexOf(this.form.fichaAnimais[this.animalRemover])
        if (xx > -1){
          var aFa = this.form.fichaAnimais.at(xx)
          if( aFa.id > 0)
            this.animalRemoverList.push(aFa)
          this.form.fichaAnimais.splice(xx, 1)          
        }
      }
    },
    doChangeV() {
      if (this.form.tipoFicha && this.form.tipoFicha.resultado == "DATA") {
        if (this.form.tipoFicha.descricaoAntes)
          this.form.descricao = this.form.tipoFicha.descricaoAntes;

        this.form.descricao = this.form.descricao + " " + this.form.valorData;

        if (this.form.tipoFicha.descricaoDepois)
          this.form.descricao =
            this.form.descricao + " " + this.form.tipoFicha.descricaoDepois;
      } else {
        this.form.descricao = "";
      }

      if (this.form.tipoFicha && this.form.tipoFicha.resultado == "INTEIRO") {
        if (this.form.tipoFicha.descricaoAntes)
          this.form.descricao = this.form.tipoFicha.descricaoAntes;

        this.form.descricao =
          this.form.descricao + " " + this.form.valorInteiro;

        if (this.form.tipoFicha.descricaoDepois)
          this.form.descricao =
            this.form.descricao + " " + this.form.tipoFicha.descricaoDepois;
      }

      if (this.form.tipoFicha && this.form.tipoFicha.resultado == "BOLEANO") {
        if (this.form.tipoFicha.descricaoAntes)
          this.form.descricao = this.form.tipoFicha.descricaoAntes;
        if (this.form.valorBoleano)
          this.form.descricao = this.form.descricao + " Sim";
        else this.form.descricao = this.form.descricao + " Não";

        if (this.form.tipoFicha.descricaoDepois)
          this.form.descricao =
            this.form.descricao + " " + this.form.tipoFicha.descricaoDepois;
      }

      if (this.form.tipoFicha && this.form.tipoFicha.resultado == "NUMERO") {
        if (this.form.tipoFicha.descricaoAntes)
          this.form.descricao = this.form.tipoFicha.descricaoAntes;

        this.form.descricao = this.form.descricao + " " + this.form.valorNumero;

        if (this.form.tipoFicha.descricaoDepois)
          this.form.descricao =
            this.form.descricao + " " + this.form.tipoFicha.descricaoDepois;
      }
    },
  },
};
</script>